package ru.it_mozaika.sender.js.application

import io.ktor.client.*
import io.ktor.client.plugins.*
import io.ktor.client.plugins.compression.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.plugins.websocket.*
import io.ktor.client.request.*
import io.ktor.client.statement.*
import io.ktor.http.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.browser.window
import kotlinx.coroutines.*
import ru.it_mozaika.sender.common.models.httpApiJson


object Http {

    private var BASE_PATH = "${window.location.origin}/api/v1"

    private val client = HttpClient {
        developmentMode = true
        expectSuccess = false
        install(ContentEncoding) {
            gzip()
        }
        install(WebSockets)
        install(ContentNegotiation) {
            json(httpApiJson)
        }
        defaultRequest {
            host = window.location.hostname
//            port = window.location.port.toIntOrNull() ?: 443
//            url.protocol = if (port == 443) URLProtocol.HTTPS else URLProtocol.HTTP
        }
    }
    fun get(
        path: String,
        query: Map<String, String> = mapOf(),
        builder: (HttpRequestBuilder.() -> Unit)? = null,
        callback: suspend (HttpResponse) -> Unit
    ) {
        CoroutineScope(Dispatchers.Unconfined).launch {
            val response = client.get("$BASE_PATH$path") {
                query.forEach { (key, value) ->
                    parameter(key, value)
                }
                builder?.invoke(this) ?: kotlin.run { contentType(ContentType.Application.Json) }
            }
            callback(response)
        }
    }
    fun delete(
        path: String,
        query: Map<String, String> = mapOf(),
        builder: (HttpRequestBuilder.() -> Unit)? = null,
        callback: suspend (HttpResponse) -> Unit
    ) {
        CoroutineScope(Dispatchers.Unconfined).launch {
            val response = client.delete("$BASE_PATH$path") {
                query.forEach { (key, value) ->
                    parameter(key, value)
                }
                builder?.invoke(this) ?: kotlin.run { contentType(ContentType.Application.Json) }
            }
            callback(response)
        }
    }
    fun post(
        path: String,
        body: Any,
        builder: (HttpRequestBuilder.() -> Unit)? = null,
        query: Map<String, String> = mapOf(),
        callback: suspend (HttpResponse) -> Unit,
    ): Deferred<Unit> {
        return CoroutineScope(Dispatchers.Unconfined).async {
            val response = client.post("$BASE_PATH$path") {
                setBody(body)
                query.forEach { (key, value) ->
                    parameter(key, value)
                }
                builder?.invoke(this) ?: kotlin.run { contentType(ContentType.Application.Json) }
            }
            callback(response)
        }
    }
    fun put(
        path: String,
        body: Any,
        builder: (HttpRequestBuilder.() -> Unit)? = null,
        callback: suspend (HttpResponse) -> Unit
    ) {
        CoroutineScope(Dispatchers.Unconfined).launch {
            val response = client.put("$BASE_PATH$path") {
               setBody(body)
                builder?.invoke(this) ?: kotlin.run { contentType(ContentType.Application.Json) }
            }
            callback(response)
        }
    }
}